
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/camp",
      function () {
        return require("private-next-pages/camp/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/camp"])
      });
    }
  